// extracted by mini-css-extract-plugin
export default {"variants":"YmOjTm","label":"UgvUOV","BoxSelectionAmountSelectorOption":"LmZg5k","boxSelectionAmountSelectorOption":"LmZg5k"};